export default String.raw`
<div class="buttons-container__links">
    {% if settings.allowCheckingAvailabilityInShop == 'yes' and config.B2B -%}
        {% comment -%}<!-- Check availability -->{% endcomment -%}
        <button class="pure-button check-availability-js">
            <svg width="20" height="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#map-marker-alt-{{settings.iconStyle}}"></use>
            </svg>
            <span>{{translations.CheckAvailabilityInShop}}</span>
        </button>

        {% include 'partials/product/check-availability-popup.html' -%}
    {% endif -%}

    {% if settings.productPurchaseHistory == 'yes' and usr.Authenticated and activeProduct.GIDNumber -%}
        {% comment -%}<!-- Check purchase history -->{% endcomment -%}
        <button class="pure-button check-purchase-history-js" data-product-id="{{activeProduct.GIDNumber}}">
            <svg width="20" height="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#clock-{{settings.iconStyle}}"></use>
            </svg>
            <span>{{translations.CheckPurchaseHistory}}</span>
        </button>

        {% include 'partials/product/purchase-history-popup.html' -%}
    {% endif -%}

    {% if settings.productsDeliveries == 'yes' and activeProduct.GIDNumber -%}
        {% comment -%}<!-- Check deliveries -->{% endcomment -%}
        <button class="pure-button check-deliveries-js" data-product-id="{{activeProduct.GIDNumber}}">
            <svg width="20" height="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#calendar-alt-{{settings.iconStyle}}"></use>
            </svg>
            <span>{{translations.CheckDeliveries}}</span>
        </button>

        {% include 'partials/product/check-deliveries-popup.html' with 'activeProduct' -%}
    {% endif -%}

    {% if usr.Authenticated -%}
        {% if activeProduct.Points != null -%}
            <div class="loyalty-info">
                {% assign unit = product.SaleUnit | ToString | Prepend: '<span>1 ' | Append: '</span>' -%}
                {% assign loyaltyAmount = activeProduct.Points | ToString | Prepend: '<strong>' | Append: '</strong>' -%}
                <svg>
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#award-{{settings.iconStyle}}'></use>
                </svg>
                <span>{{ translations.EarnLoyaltyPoints | Format: loyaltyAmount, unit }}</span>
            </div>
        {% endif -%}
        {% if activeProduct.PointsPrice != null and product.Clip == true -%}
            {% assign pointsPrice = activeProduct.PointsPrice -%}
            <div class="loyalty-info ">
                <svg>
                    <use href='css/img/fontawesome-icons.svg?v={{lqTS}}#gift-card-{{settings.iconStyle}}'></use>
                </svg>
                <span data-basic="{{ product.PointsPrice }}" class="amount">{{ translations.PayViaLoyaltyPoints }} - <strong>{{ pointsPrice }} {{ translations.PointsShortcut }}</strong></span>
            </div>
        {% endif -%}
    {% endif -%}

    {% if settings.deligoo == 'yes' -%}
        {% comment -%}<!-- Check Deligoo -->{% endcomment -%}
        <button class="pure-button check-deligoo-availability-js"> 
            <svg width="20" height="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#truck-{{settings.iconStyle}}"></use>
            </svg>
            <span>{{translations.CheckDeligooAvailability}}</span>
        </button>
        {% include 'partials/product/check-deligoo-popup.html' -%}
    {% endif -%}

    <div class="pure-button delivery-cost-button hidden-js"> 
        <svg width="20" height="20">
            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#truck-{{settings.iconStyle}}"></use>
        </svg>
        <span>
            {{translations.Delivery}}
            <a class="delivery-cost-link" href="{{ page.BaseHref }}{{config.DefinedPages.Shipping.Url}}">
                {{ translations.Sea_From | Downcase }} <span class="delivery-cost-js"></span> {{ currencyExt }}
            </a>
        </span>
    </div>

    <script>
        Number.prototype.format = function (n, x, s, c) {
            var suffix;
            if (n > 0) {
                suffix = '\\D';
            } else {
                suffix = '$';
            }
            var re = '\\d(?=(\\d{' + (x || 3) + '})+' + suffix + ')',
                num = this.toFixed(Math.max(0, ~ ~n));
            var result;
            if (c) {
                result = num.replace('.', c);
            } else {
                result = num;
            }
            return result.replace(new RegExp(re, 'g'), '$&' + (s || ','));
        }; 

        Number.prototype.toPrice = function () {
            return this.format(__decimalPlacesPrice, 3, __decThoSep, __decSep);
        }

        $.get('', {__action:'Product/DeliveryCostGet', id: '{{activeProduct.Id}}' },function(res) {
            if (res.action.Object !== null && res.action.Object.Cost !== null && res.action.Object.Cost >= 0) {
                $('.delivery-cost-button').removeClass('hidden-js');
                $('.delivery-cost-js').text(res.action.Object.Cost.toPrice());
            } else {
                $('.delivery-cost-button').addClass('hidden-js');
            }
        });
    </script>

    {% if settings.sizeChart != 'no' -%}
        {% comment -%}<!-- Size Chart -->{% endcomment -%}
        {% if settings.sizeChart == 'forAllProducts' or settings.sizeChart == 'forOnlyProductsWithVariants' and product.HasAttributes -%}
            {% if settings.variantsOfSizeChart == 'sizeChart-banner'  -%}
                {% if config.Banners['SizeTable'] != null -%}
                    <button class="pure-button show-size-chart-popup-js">
                        <svg width="20" height="20">
                            <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ruler-{{settings.iconStyle}}"></use>
                        </svg>
                        <span>{{ translations.SizeChart }}</span>
                    </button>
                    {% include 'partials/product/size-chart-popup.html' -%}
                {% endif -%}
            {% elsif settings.variantsOfSizeChart == 'sizeChart-site' -%}
                {% assign sizeChartBase = page.BaseHref -%}
                {% for page in config.Pages %}
                    {% if page.Id == settings.sizeChartSiteID -%}
                        {% capture sizeChartHref -%}{% include 'partials/common/user-link.html', userLink: page.Url, userBase: sizeChartBase -%}{% endcapture -%}
                        <a class="pure-button" href="{{ sizeChartHref }}" target="_blank">
                            <svg width="20" height="20">
                                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ruler-{{settings.iconStyle}}"></use>
                            </svg>
                            <span>{{ translations.SizeChart }}</span>
                        </a>
                    {% endif -%}
                {% endfor %}   
            {% else -%}
                {% if product.Attachments[0] -%}
                    {% for file in product.Attachments -%}
                        {% if file.Url != "" -%}
                            {% assign type = file.Url | Split: '.' | Last -%}

                            {% if file.Type == "Document" and file.Extension != "txt" and type != "txt" -%}
                                {% assign wordType = true -%}
                            {% else -%}
                                {% assign wordType = false -%}
                            {% endif -%}

                            {% if file.Extension == 'pdf' -%}
                                {% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
                                <a class="pure-button" href="{{ fileHref }}" target="_blank" {% if file.NoFollow -%} rel="nofollow" {% endif -%}>
                                    <svg width="20" height="20">
                                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#ruler-{{settings.iconStyle}}"></use>
                                    </svg>
                                    <span>{{ translations.SizeChart }}</span>
                                </a>
                                {% break %}
                            {% endif -%}
                        {% endif -%}
                    {% endfor -%}
                {% endif -%} 
            {% endif -%}
        {% endif -%}
    {% endif -%}
    {% unless customer.HidePrices == true and customer.Authenticated == false -%}
        {% if product.Price != null -%}
            {% include 'partials/product/installment-calculator.html' with: product -%}
        {% endif -%}
    {% endunless -%}
</div>
`